import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentUser: null
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCurrentUser: (state, action) => {
      console.log('setCurrentUser action.payload:', action.payload);
      console.log('setCurrentUser state.currentUser:', state.currentUser);
      return {
        ...state,
        currentUser: action.payload
      }
    }
  }
});

export const userReducer = userSlice.reducer;

export const { setCurrentUser } = userSlice.actions;

export const selectCurrentUser = (state) => state.user.currentUser;
